<template>
  <v-layout
    row
    wrap
  >
    <v-flex xs12>
      <div class="mb-3">
        <v-btn
          :disabled="maxDepth + 1 <= depth"
          small
          flat
          color="primary"
          @click="handleClickAddRule"
        >
          {{ addRuleText }}
        </v-btn>
      </div>

      <v-layout
        v-for="(child, index) in query.children"
        :key="`1${child.type}-${index}`"
        row
        wrap
      >
        <v-flex
          xs12
          class="my-0 py-0"
        >
          <v-layout
            v-if="child.type === 'rule'"
            class="ml-0"
          >
            <query-builder-rule
              :ref="`rule${index}`"
              :index="`${position}${depth}${index}`"
              :position="index"
              :operators="operators"
              :operands="operands"
              :query="child.query"
              @change-operand="handleChangeOperand"
              @change-operator="handleChangeOperator"
              @change-value="handleChangeValue"
              @enter-keyup="handleEnterKeyUp"
            />
            <v-tooltip bottom>
              <v-btn
                slot="activator"
                icon
                class="mt-2"
                @click="handleClickRemoveRule(index)"
              >
                <v-icon color="grey">
                  cancel
                </v-icon>
              </v-btn>
              <span>{{ removeRuleText }}</span>
            </v-tooltip>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import QueryBuilderRule from './SimpleQueryBuilderRule.vue'

export default {
  name: 'QueryBuilderGroup',

  components: {
    QueryBuilderRule
  },

  props: {
    types: {
      type: Array,
      required: true
    },
    operators: {
      type: Array,
      required: true
    },
    operands: {
      type: Array,
      required: true
    },
    query: {
      type: Object,
      required: true
    },
    depth: {
      type: Number,
      default: 1
    },
    maxDepth: {
      type: Number,
      default: 3
    },
    parent: {
      type: Object,
      default () {
        return null
      }
    },
    position: {
      type: Number,
      default: 0
    },
    addGroupText: {
      type: String,
      default: '+ group'
    },
    addRuleText: {
      type: String,
      default: '+ condition'
    },
    removeGroupText: {
      type: String,
      default: 'Remove group'
    },
    removeRuleText: {
      type: String,
      default: 'Remove condition'
    }
  },

  methods: {
    handleAddGroup () {
      this.$emit('add-group', ...arguments)
    },

    handleAddRule () {
      this.$emit('add-rule', ...arguments)
    },

    handleRemoveGroup () {
      this.$emit('remove-group', ...arguments)
    },

    handleRemoveRule () {
      this.$emit('remove-rule', ...arguments)
    },

    handleClickAddGroup () {
      const group = {
        type: 'group',
        query: {
          operator: 'ALL',
          children: [
            {
              type: 'rule',
              query: {
                operator: '',
                operand: '',
                value: ''
              }
            }
          ]
        }
      }
      this.query.children.push(group)
      this.$emit('add-group', group, this.query, this.parent)
    },

    handleClickAddRule () {
      const query = {
        type: 'rule',
        query: {
          operator: '',
          operand: '',
          value: ''
        }
      }
      this.query.children.push(query)
      this.$emit('add-rule', query, this.query, this.parent)
    },

    handleClickRemoveRule (index) {
      const deleted = this.query.children.splice(index, 1)[0]
      this.$emit('remove-rule', deleted, index, this.query)
    },

    handleClickRemoveGroup (index) {
      const query = this.parent.children.splice(index, 1)[0]
      this.$emit('remove-group', query, this.position)
    },

    handleChangeOperand (operand, query, positions) {
      this.$emit('change-operand', operand, query, this.query, positions)
    },

    handleChangeOperator (operator, query, positions) {
      if (this.position !== 0) {
        positions.push(this.position)
      }
      this.$emit('change-operator', operator, query, this.query, positions)
    },

    handleChangeValue (value, query, positions) {
      if (this.position !== 0) {
        positions.push(this.position)
      }
      this.$emit('change-value', value, query, this.query, positions)
    },

    handleEnterKeyUp (event) {
      this.$emit('enter-keyup', event)
    }
  }
}
</script>

<style scoped>
.nested {
  outline: 1px solid blue;
}
</style>
